module.exports = __webpack_public_path__ + "static/sangyulee-7aa5717bd18e7e315b2d01d8b5e27659.jpeg";